import URLSearchParams from '@ungap/url-search-params'

function handleChange ({ target }, searchParams) {
  target.classList.add('clc-Sorting_Button-active')
  searchParams.set('sort_by', target.value)
  window.location.search = searchParams.toString()
}

export default function init ({ el, context }) {
  const sortButtons = document.getElementsByClassName(`clc-Sorting_Button`)

  const searchParams = new URLSearchParams(window.location.search) 
  let lastScroll = 0;
  for (var i = sortButtons.length - 1; i >= 0; i--) {
    const changeEvent = event => handleChange(event, searchParams)
    sortButtons[i].addEventListener('click', changeEvent)
  }

  const filterElementHeight = document.getElementsByClassName('clc-Collection_Body')[0]
  const filterFixable = document.getElementsByClassName('clc-Collection_Actions')[0]
  const mmMain = document.getElementsByClassName('mn-Main')[0]
  function scrollFunction () {

    const currentScroll = window.pageYOffset;
    var scrollY = window.scrollY || window.pageYOffset
    var scrollX = window.innerWidth
    
    if (scrollY > filterElementHeight.offsetTop && scrollX < 769 && currentScroll < lastScroll) {
      if(!filterFixable.classList.contains('fixed_Filters')){
        filterFixable.classList.add('fixed_Filters')
      }
    } else {
      if(filterFixable.classList.contains('fixed_Filters')){
        filterFixable.classList.remove('fixed_Filters')
      }
    }
    //console.log(`lastScroll is ${lastScroll}`)
    //console.log(`currentScroll is ${currentScroll}`)
    lastScroll = currentScroll;
  }

  window.addEventListener('DOMContentLoaded', () => {
    //scrollFunction ()
  })
  window.addEventListener('scroll', () => {
    //scrollFunction ()
  })
}
